import { HomeScreens } from "@modules/home/navigation";
import { navigationService } from "@navigation";

const allowedGuestRoutes: any = [
  HomeScreens.HOME_SCREEN,
  HomeScreens.MAINTENANCE_SCREEN,
];

export const navigationPermission = (state: any, store: any) => {
  const isUserLogin = store.getState()?.auth?.isLogin;
  const activeRouteName = navigationService.getActiveRouteName();
  if (!isUserLogin && !allowedGuestRoutes.includes(activeRouteName)) {
    navigationService.navigate(HomeScreens.HOME_SCREEN);
  }
};
